/**
 * Whether a markdown/plain-text field carries anything worth rendering.
 * Mirrors `NotesPanel`'s `hasNotes` check — a value made only of whitespace
 * (e.g. an editor that was cleared but left an empty paragraph) counts as
 * empty.
 */
export function hasContent(value: string | null | undefined): boolean {
  return !!value && value.trim().length > 0
}
